module.exports = __webpack_public_path__ + "media/images/clutch_kits/TRP-bb5afa84c1ea6d2fb2085e63dcf6a2a2.jpg";